@import "../../common/css/variable.css";
:host {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: var(--button-height, 32px);
  line-height: var(--button-height, 32px);
  text-align: center;
  border-radius: var(--button-border-radius, 16px);
  padding-left: 12px!important;
  padding-right: 12px!important;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  vertical-align: bottom;
}

:host .jackery-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: var(--button-border-radius, 16px);
  cursor: unset;
  -webkit-tap-highlight-color: transparent;
}

:host(:not([size])) {
  font-size: var(--button-font-size, 14px);
}

:host([size="small"]) {
  height: var(--button-height, 24px);
  line-height: var(--button-height, 24px);
  font-size: var(--button-font-size, 12px);
}

:host([size="big"]) {
  height: var(--button-height, 40px);
  line-height: var(--button-height, 40px);
  font-size: var(--button-font-size, 16px);
  border-radius: var(--button-big-border-radius, 8px);
  width: 100%;
}

:host([size="large"]) {
  height: var(--button-height, 48px);
  line-height: var(--button-height, 48px);
  font-size: var(--button-font-size, 18px);
  border-radius: var(--button-big-border-radius, 8px);
  width: 100%;
}

:host([shape="square"]) {
  border-radius: 0;
}

:host(:not([type])) {
  color: var(--button-color, #5A6066);
  border: 1px solid #E1E6EB;
}

:host([type="primary"]) {
  color: var(--text-white-color);
  background: var(--primary-color);
}

:host([type="warning"]) {
  color: var(--text-white-color);
  background: var(--warning-color);
}

:host([type="danger"]) {
  color: var(--text-white-color);
  background: var(--danger-color);
}

:host([type="success"]) {
  color: var(--text-white-color);
  background: var(--success-color);
}

:host([plain]) {
  border: 1px solid;
}

:host([plain][type="primary"]) {
  color: var(--primary-color);
  border-color: var(--primary-color);
  background: transparent;
}

:host([plain][type="warning"]) {
  color: var(--warning-color);
  border-color: var(--warning-color);
  background: transparent;
}

:host([plain][type="danger"]) {
  color: var(--danger-color);
  border-color: var(--danger-color);
  background: transparent;
}

:host([plain][type="success"]) {
  color: var(--success-color);
  border-color: var(--success-color);
  background: transparent;
}

:host([light]) {
  background: var(--jackery-light-color, #E1E6EB);
}

:host([light][type="primary"]) {
  background: #E6F4FF;
  color: var(--primary-color);
}

:host([light][type="warning"]) {
  background: #FEF4E7;
  color: var(--warning-color);
}

:host([light][type="danger"]) {
  background: #FEE9E9;
  color: var(--danger-color);
}

:host([light][type="success"]) {
  background: #E6F8EF;
  color: var(--success-color);
}

:host([loading]) {
  cursor: not-allowed;
  user-select: none;
}
:host jackery-loading {
  display: none;
}
:host([loading]) jackery-loading {
  display: unset;
}

:host([disabled]) {
  cursor: not-allowed;
  user-select: none;
  color: #BCC4CC;
}

:host([disabled][type]) {
  background: #DBDBDB;
  color: #fff;
}

:host(:active) .jackery-button::before {
  opacity: 0.05;
}

:host([disabled]) .jackery-button::before,
:host([loading]) .jackery-button::before {
  display: none;
}

:host .jackery-button::before {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background-color: #000;
  border: inherit;
  border-color: #000;
  border-radius: inherit;
  transform: translate(-50%, -50%);
  opacity: 0;
  content: "";
}

.jackery-button:not([disabled]):active::after {
  transform: translate(-50%, -50%) scale(0);
  opacity: 0.05;
  transition: 0s;
}

:host .jackery-button-load {
  margin-right: var(--button-icon-hspacing, 6px);
}

:host .jackery-button-icon {
  width: var(--button-icon-size, 1em);
  height: auto;
  margin-right: var(--button-icon-hspacing, 5px);
}